import { render, staticRenderFns } from "./modal-backdrop.vue?vue&type=template&id=c38db784&"
import script from "./modal-backdrop.vue?vue&type=script&lang=js&"
export * from "./modal-backdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports